import Vue from "vue";
import Router from "vue-router";
import { getCookie } from '@util/cookie';
import { checkGrayItem } from "@util/handleGrayByLocalstorage";

const Dashboard = r => require.ensure([], () => r(require('./router/Dashboard/Dashboard.vue')), 'Dashboard');

//菜谱发布管理
const MenuManage = r => require.ensure([], () => r(require('./router/Menu/MenuManage.vue')), 'Menu');
const MenuRepublish = r => require.ensure([], () => r(require('./router/Menu/MenuRepublish.vue')), 'Menu');

//总部菜谱(时段菜)
const MenuHqList = r => require.ensure([], () => r(require('./router/Menu/MenuList.vue')), 'Menu');
const MenuPublish = r => require.ensure([], () => r(require('./router/Menu/MenuPublish.vue')), 'Menu');
const FoodEdit = r => require.ensure([], () => r(require('./router/Menu/FoodEdit.vue')), 'Menu');

//营业收入报表
const BusiStatistics = r => require.ensure([], () => r(require('./router/BusinessReport/BusiStatistics/BusiStatistics.vue')), 'BusinessReport');
const PayType = r => require.ensure([], () => r(require('./router/BusinessReport/PayType/PayType.vue')), 'BusinessReport');
const InvoiceReport = r => require.ensure([], () => r(require('./router/BusinessReport/InvoiceReport/InvoiceReport.vue')), 'BusinessReport');

const BillDetail = r => require.ensure([], () => r(require('./router/BusinessReport/' +
  'BillDetail/BillDetail.vue')), 'BusinessReport');
const SettlementStatistics = r => require.ensure([], () => r(require(
  './router/BusinessReport/SettlementStatistics/SettlementStatistics.vue')), 'BusinessReport');
const SettlementHotelSummary = r => require.ensure([], () => r(require(
  './router/BusinessReport/SettlementStatistics/SettlementHotelSummary.vue')), 'BusinessReport');
const SettlementHotelDetail = r => require.ensure([], () => r(require(
  './router/BusinessReport/SettlementStatistics/SettlementHotelDetail.vue')), 'BusinessReport');

const Gather = r => require.ensure([], () => r(require('./router/FoodReport/Gather/Gather.vue')), 'FoodReport');
const GatherTotal = r => require.ensure([], () => r(require('./router/FoodReport/Gather/GatherTotal.vue')), 'FoodReport');
const SingleSaleReport = r => require.ensure([], () => r(require('./router/FoodReport/Gather/SingleSaleReport.vue')), 'FoodReport');
const PackageSaleReport = r => require.ensure([], () => r(require('./router/FoodReport/Gather/PackageSaleReport.vue')), 'FoodReport');
const GatherTakeOut = r => require.ensure([], () => r(require('./router/FoodReport/Gather/GatherTakeOut.vue')), 'FoodReport');

const Rank = r => require.ensure([], () => r(require('./router/FoodReport/Rank/Rank.vue')), 'FoodReport');
const RankDineIn = r => require.ensure([], () => r(require('./router/FoodReport/Rank/RankDineIn.vue')), 'FoodReport');
const RankTakeOut = r => require.ensure([], () => r(require('./router/FoodReport/Rank/RankTakeOut.vue')), 'FoodReport');

const FoodType = r => require.ensure([], () => r(require('./router/FoodReport/FoodType/FoodType.vue')), 'FoodReport');

const AdditionSaleReport = r => require.ensure([], () => r(require('./router/FoodReport/AdditionSaleReport/AdditionSaleReport.vue')), 'FoodReport');

const Period = r => require.ensure([], () => r(require('./router/FoodReport/Period/Period.vue')), 'FoodReport');

const Commission = r => require.ensure([], () => r(require('./router/FoodReport/Commission/Commission.vue')), 'FoodReport');

//收银异常报表
const FoodGift = r => require.ensure([], () => r(require('./router/CashierException/FoodGift/FoodGift.vue')), 'CashierException');
const FoodBack = r => require.ensure([], () => r(require('./router/CashierException/FoodBack/FoodBack.vue')), 'CashierException');
const FreeOfChargeDetail = r => require.ensure([], () => r(require('./router/CashierException/FreeOfChargeDetail/FreeOfChargeDetail.vue')), 'CashierException');
const DiscountDetail = r => require.ensure([], () => r(require('./router/CashierException/DiscountDetail/DiscountDetail.vue')), 'CashierException');
const AntiSettlement = r => require.ensure([], () => r(require('./router/CashierException/AntiSettlement/AntiSettlement.vue')), 'CashierException');

//消息中心
const MidwarePage = r => require.ensure([], () => r(require('./router/MidwarePage.vue')), 'Others');
const MessageCenter = r => require.ensure([], () => r(require('./router/MessageCenter/MessageCenter.vue')), 'Others');

//会员管理（一键迁移）
const MemberTransfer = r => require.ensure([], () => r(require('./router/Member/MemberTransfer/MemberTransfer.vue')), 'Member');
const NoticeMemberTransfer = r => require.ensure([], () => r(require('./router/Member/MemberTransfer/Notice.vue')), 'Member');
const CheckMemberTransfer = r => require.ensure([], () => r(require('./router/Member/MemberTransfer/Check.vue')), 'Member');
const TestMemberTransfer = r => require.ensure([], () => r(require('./router/Member/MemberTransfer/Test.vue')), 'Member');
const TestMemberTransfer1 = r => require.ensure([], () => r(require('./router/Member/MemberTransfer/Test1.vue')), 'Member');


Vue.use(Router);
let routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/Menu/MenuHqList',
    name: 'MenuHqList',
    component: MenuHqList,
    meta: {
      cid: 'c_52pdqapy',
      title: '总部菜谱'
    }
  },
  {
    path: '/Menu/MenuHqList/MenuPublish',
    name: 'MenuPublish',
    component: MenuPublish,
    meta: {
      title: [{
        name: '总部菜谱',
        path: '/Menu/MenuHqList'
      }, {
        name: '菜谱发布'
      }]
    }
  },
  {
    path: '/Menu/MenuHqList/FoodEdit',
    name: 'FoodEdit',
    component: FoodEdit,
    meta: {
      cid: 'c_90yezxfp',
      title: [{
        name: '总部菜谱',
        path: '/Menu/MenuHqList'
      }, {
        name: '设置菜品'
      }]
    }
  },
  {
    path: '/Menu/MenuManage',
    name: 'MenuManage',
    component: MenuManage,
    meta: {
      cid: 'c_4cw1lzng',
      title: '菜谱发布管理'
    }
  },
  {
    path: '/Menu/MenuManage/MenuRepublish/:id',
    name: 'MenuRepublish',
    component: MenuRepublish,
    meta: {
      title: [{
        name: '菜谱发布管理',
        path: '/Menu/MenuManage'
      }, {
        name: '菜谱重新发布'
      }]
    }
  },
  {
    path: '/BusinessReport/BusiStatistics',
    name: 'BusiStatistics',
    component: BusiStatistics
  },
  {
    path: '/BusinessReport/PayType',
    name: 'PayType',
    component: PayType
  },
  {
    path: '/BusinessReport/InvoiceReport',
    name: 'InvoiceReport',
    component: InvoiceReport
  },
  {
    path: '/BusinessReport/BillDetail',
    name: 'BillDetail',
    component: BillDetail
  },
  {
    path: '/BusinessReport/SettlementStatistics',
    name: 'SettlementStatistics',
    component: SettlementStatistics
  },
  {
    path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary',
    name: 'SettlementHotelSummary',
    component: SettlementHotelSummary,
    meta: {
      title: [{
        name: '结算信息统计表',
        path: '/BusinessReport/SettlementStatistics'
      }, {
        name: '门店汇总'
      }]
    }
  },
  {
    path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary/SettlementHotelDetail',
    name: 'SettlementHotelDetail',
    component: SettlementHotelDetail,
    meta: {
      title: [{
        name: '结算信息统计表',
        path: '/BusinessReport/SettlementStatistics'
      }, {
        name: '结算信息门店汇总',
        path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary',
        className: 'settlement-summary-breadcrumb'
      }, {
        name: '交易明细'
      }]
    }
  },
  {
    path: '/FoodReport/Gather',
    component: Gather,
    children: [{
      path: '',
      name: 'GatherTotal',
      component: GatherTotal
    }, {
      path: '/FoodReport/Gather/SingleSaleReport',
      name: 'SingleSaleReport',
      component: SingleSaleReport
    }, {
      path: '/FoodReport/Gather/PackageSaleReport',
      name: 'PackageSaleReport',
      component: PackageSaleReport
    }, {
      path: '/FoodReport/Gather/GatherTakeOut',
      name: 'GatherTakeOut',
      component: GatherTakeOut
    }]
  },
  {
    path: '/FoodReport/Rank',
    component: Rank,
    children: [{
      path: '',
      name: 'RankDineIn',
      component: RankDineIn
    }, {
      path: '/FoodReport/Rank/RankTakeOut',
      name: 'RankTakeOut',
      component: RankTakeOut
    }]
  },
  {
    path: '/FoodReport/FoodType',
    name: 'FoodType',
    component: FoodType
  },
  {
    path: '/FoodReport/AdditionSaleReport',
    name: 'AdditionSaleReport',
    component: AdditionSaleReport
  },
  {
    path: '/FoodReport/Period',
    name: 'Period',
    component: Period
  },
  {
    path: '/FoodReport/Commission',
    name: 'PercentAge',
    component: Commission
  },
  {
    path: '/CashierException/FoodGift',
    name: 'FoodGift',
    component: FoodGift
  },
  {
    path: '/CashierException/FoodBack',
    name: 'FoodBack',
    component: FoodBack
  },
  {
    path: '/CashierException/FreeOfChargeDetail',
    name: 'FreeOfChargeDetail',
    component: FreeOfChargeDetail
  },
  {
    path: '/CashierException/DiscountDetail',
    name: 'DiscountDetail',
    component: DiscountDetail
  },
  {
    path: '/CashierException/AntiSettlement',
    name: 'AntiSettlement',
    component: AntiSettlement
  },
  {
    path: '/Service/DownloadCenter',
    name: 'DownloadCenter',
    component: {
      template: '<comp-download-center/>'
    },
    meta: {
      cid: 'c_eco_m81yc73q'
    }
  },
  {
    path: '/Midware',
    name: 'Midware',
    component: MidwarePage
  },
  {
    path: '/MessageCenter',
    name: 'MessageCenter',
    component: MessageCenter,
    meta: {
      title: '消息中心',
      cid: 'c_mrqd6ax2'
    }
  },
  {
    path: '/Member/MemberTransfer',
    name: 'MemberTransfer',
    component: MemberTransfer,
  },
  {
    path: '/Member/MemberTransfer/NoticeMemberTransfer',
    name: 'NoticeMemberTransfer',
    component: NoticeMemberTransfer,
  },
  {
    path: '/Member/MemberTransfer/CheckMemberTransfer',
    name: 'CheckMemberTransfer',
    component: CheckMemberTransfer,
  },
  {
    path: '/Member/MemberTransfer/TestMemberTransfer',
    name: 'TestMemberTransfer',
    component: TestMemberTransfer,
  },
  {
    path: '/Member/MemberTransfer/TestMemberTransfer1',
    name: 'TestMemberTransfer1',
    component: TestMemberTransfer1,
  }
];

if (checkGrayItem('pingxin_fe_hq-static_feature')) {
  routes = routes.concat([
    {
      path: '/System/Download',
      name: 'Download',
      component: {
        template: '<comp-appoint-download />'
      }
    }
  ]);
}

export default new Router({
  routes: routes
});




// WEBPACK FOOTER //
// ./src/router.js